import { classNames } from '@progress/kendo-react-common'
import Translation from 'components/Translation'
import { useAppointmentDrawerContext } from 'context/appointmentDrawerContext/AppointmentDrawerContainer'
import { useTenantContext } from 'context/TenantContext'
import React, { useEffect, useState } from 'react'
import { useApiRequest } from 'utils/fetch-helper'
import { validateEmail } from 'utils/string-helper'
import { toCurrency } from 'utils/string-localization-helper'

function CouponValidity() {
    const { getApiRequest } = useApiRequest()
    const { tenant } = useTenantContext()
    const {
        couponCode,
        setCouponCode,
        selectedClient,
        shouldApplyCouponCode,
        setIsValidCouponCode,
        isValidCouponCode,
        formData: { service },
        setCouponInfo,
    } = useAppointmentDrawerContext()
    const [couponData, setCouponData] = useState<any>(undefined)
    useEffect(() => {
        if (shouldApplyCouponCode) handleCouponChange(couponCode)
    }, [service, shouldApplyCouponCode])

    const handleCouponChange = async (code: string) => {
        let query_params: Record<string, string> = {
            tenantId: tenant?.id as string,
            serviceId: service as string,
            email: selectedClient?.user?.email as string,
            couponCode: code,
        }

        const validCoupon = await getApiRequest(
            `/v1/coupons/check-coupon-availability-with-email?${Object.keys(
                query_params
            )
                .map((key: string) => {
                    if (query_params[key] != undefined) {
                        return `${key}=${encodeURIComponent(query_params[key])}`
                    }
                })
                .join('&')}`
        )
        if (validCoupon?.id) {
            setIsValidCouponCode(true)
            setCouponData(validCoupon)
            setCouponInfo(validCoupon)
        } else {
            setIsValidCouponCode(false)
        }
    }

    return (
        <fieldset
        // className={classNames(has_coupon ? '' : 'hidden', 'w-72 mb-4')}
        >
            <label
                className="w-full text-gray-800 relative"
                htmlFor="coupon_code"
            >
                <p className="leading-loose">
                    <Translation
                        content_key="coupon_code"
                        render_as="span"
                    />
                    &nbsp;
                    <small>
                        <Translation content_key="allow_full_discount" />
                    </small>
                    {!validateEmail(selectedClient?.user?.email as string) ? (
                        <>
                            {'. '}
                            <sup className="text-slate-500">
                                *
                                <Translation content_key="valid_email_required" />
                            </sup>
                        </>
                    ) : (
                        ''
                    )}
                </p>

                <input
                    className={classNames(
                        'w-full rounded-lg border border-gray-300 placeholder-gray-300 disabled:bg-gray-100/80 disabled:border-gray-100',
                        isValidCouponCode
                            ? 'bg-green-100/60 text-green-800 font-semibold'
                            : 'bg-red-100 bg-opacity-50 text-red-800 border-red-300'
                    )}
                    type="text"
                    id="coupon_code"
                    name="coupon_code"
                    autoComplete={'false'}
                    defaultValue={couponCode}
                    disabled={
                        !validateEmail(selectedClient?.user?.email as string)
                    }
                    onChange={(e) => {
                        handleCouponChange(e.target.value)
                        setCouponCode(e.target.value)
                    }}
                />

                {couponCode.length > 0 ? (
                    isValidCouponCode ? (
                        <i
                            className={classNames(
                                'feather-check-circle text-green-500',
                                ' absolute right-3 top-[34px] text-xl'
                            )}
                        />
                    ) : (
                        <i
                            className={classNames(
                                'feather-x-circle text-red-500',
                                ' absolute right-3 top-[34px] text-xl'
                            )}
                        />
                    )
                ) : (
                    ''
                )}
            </label>

            {couponData && isValidCouponCode && (
                <span className="ml-1 text-xs text-gray-400">
                    <Translation content_key="coupon_applied_appt" /> &nbsp;
                    {couponData.discountType === 'PERCENT' ? (
                        <span className="text-green-500">
                            {couponData?.discountValue} &nbsp;
                            {'%'}
                        </span>
                    ) : (
                        <span className="text-green-500">
                            {toCurrency(couponData?.discountValue)}
                        </span>
                    )}
                    &nbsp; <Translation content_key="discount" />
                </span>
            )}
        </fieldset>
    )
}

export default CouponValidity
